module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9648.19a17a19.jpg";